
var themeController = function () {
    
    function sidebar() {
        

        $('a.sidebar-toggle').on('click', function(){

            if(!$('#sidebar').hasClass('collapsed')){
                $('#sidebar').addClass('collapsed');
            }else{
                $('#sidebar').removeClass('collapsed');
            }
        });
    }
    
    return {
        init: function() {
            sidebar();
        }
    };
}();
    
$(function () {
    themeController.init();
});
